import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/woonboulevard-poortvliet.svg")